export type ArchivedDocument = {
    path: string;
    expirationDate: string;
    size: number;
    retentionYears: number;
    storageRegion: string;
    signature: {
        signatory: string;
        date: string;
        location: string;
        reason: string;
        certificate: {
            serialNumber: string;
            validityStartDate: string;
            validityEndDate: string;
            subject: string;
            issuer: string;
        };
        digitalizationSoftware: {
            name: string;
            version: string;
        };
    };
    metadata: {
        FileName: string;
        InvoiceId: string;
        CompanyId: string;
        InvoiceNumber: string;
        InvoiceDate: string;
    };
};
